<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title border-bottom pb-2" style="margin-bottom: 0;"> {{ $t('tasks.modal.chat_notes') }}</h5>

      <!-- Chat and notes card: Chat-->
      <div class="chat-message-area-wrap">
        <div class="form-control scrollable-height-260 pt-3 chat-message-area" ref="chatContainer">
          <div v-if="previousComments && previousComments.length" style="width: 100%;">
            <div
              v-for="(comment, comment_index) in previousComments"
              class="mt-3"
              :key="comment_index"
            >
              <div :class="['chat-row', { 'chat-row-self': isCommentOwner(comment) }]">

                <Avatar
                  v-if="shouldShowAvatar(comment, comment_index)"
                  class="ml-2 mr-2"
                  :object="comment.user"
                  size="xs"
                />
                <div v-else class="ml-2 mr-2 avatar-placeholder"></div>

                <div class="chat-message">
                  <div v-if="comment.comment && comment.comment.length > 300">
                    <p v-if="comment.expanded" class="text-formatted">
                      {{ comment.comment }}
                    </p>
                    <p v-else class="text-formatted">
                      {{ comment.comment | truncate(300) }}
                    </p>

                    <div class="mt-1" @click="comment.expanded = !comment.expanded">
                      <span class="cursor-pointer" v-if="!comment.expanded">
                        <span class="mr-2 chat-view-more">{{ $t('system.view_more') }}</span>
                      </span>
                      <span class="cursor-pointer" v-if="comment.expanded">
                        <span class="mr-2 chat-view-more">{{ $t('system.view_less') }}</span>
                      </span>
                    </div>
                  </div>

                  <p
                    v-if="comment.comment && comment.comment.length <= 300"
                    class="text-formatted"
                  >
                    {{ comment.comment }}
                  </p>
                </div>

                <span class="chat-message-datetime">
                  {{ comment.updated_at | formatDateTime }}
                </span>

                <span
                  class="delete-button"
                  v-if="isCommentOwner(comment) && selectedTask.status !== 'completed'"
                  @click="openDeleteCommentModal(comment)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </div>
            </div>
          </div>

          <div v-if="!loadingComments && !previousComments.length" class="text-center">
            <h6>
              {{ $t('system.no_results') }}
            </h6>
          </div>
        </div>

        <div v-if="!loadingComments && previousComments.length" class="chat-message-top-fog"></div>
      </div>

      <div class="mt-3 mb-3">
        <div class="row" v-if="selectedTask.data_status != 'completed' && selectedTask.status != 'completed'">
          <div class="chat-box-col-text">
            <b-form-textarea
                ref="chatInput"
                qid="chat-input-field"
                v-model="comment"
                class="chat-box-text"
                rows="1"
                max-rows="4"
                :placeholder="$t('tasks.modal.question_to_recipient_label')"
                @input="resizeChatInput"
                style="resize:none;overflow-y:hidden;"
            ></b-form-textarea>
          </div>
          <div class="chat-box-col-button cursor-pointer">
            <div
                class="btn chat-box-button"
                @click="handleAddCommentSubmit"
                v-b-tooltip.hover
                :title="$t('tasks.modal.send_button_label')"
            >
              <font-awesome-icon icon="paper-plane" />
            </div>
          </div>
        </div>
      </div>


      <!-- Chat and notes card: Notes-->
      <b-form-group
        v-if="selectedTask && selectedTask.add_notes && selectedTask.add_notes == 'Optional' || selectedTask.add_notes == 'Mandatory'"
        class="mb-3">
        <label qid="assessment-form-notes-label" style="font-size: medium;" class="mt-3">
          {{ $t('tasks.modal.notes_label') }}
          <span class="text-red" v-if="selectedTask && selectedTask.add_notes == 'Mandatory'">*</span>
        </label>

        <span class="btn section-btn text-success cursor-pointer float-right mt-2" @click="editModeNotes = !editModeNotes"
          v-if="!editModeNotes && selectedTask.status != 'completed'">
          <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
        </span>

        <span class="btn section-btn text-danger cursor-pointer float-right" @click="discardNotes(selectedTask)"
          v-if="editModeNotes && selectedTask.status != 'completed'">
          {{ $t('tasks.modal.discard') }}
        </span>

        <span class="btn section-btn text-success cursor-pointer float-right" @click="updateNotes(selectedTask)"
          v-if="editModeNotes && selectedTask.status != 'completed'">
          {{ $t('tasks.modal.save') }}
        </span>

        <b-form-textarea qid="assessment-form-notes" v-model="taskForm.notes"
          v-if="editModeNotes && selectedTask.status != 'completed'" rows="6" max-rows="6"
          :required="selectedTask.add_notes == 'Mandatory'" :placeholder="$t('tasks.modal.notes_placeholder')"></b-form-textarea>

        <div v-if="!editModeNotes || selectedTask.status == 'completed'" style="margin-top: -20px;">
          <div v-if="taskForm.notes && taskForm.notes.length > 300">
            <p v-if="showFullTextNotes" class="text-formatted">
              {{ taskForm.notes }}
            </p>

            <p v-if="!showFullTextNotes" class="text-formatted">
              {{ taskForm.notes | truncate(300) }}
            </p>

            <div class="text-center mt-3" @click="showFullTextNotes = !showFullTextNotes">
              <span class="cursor-pointer" v-if="!showFullTextNotes">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down" />
              </span>
              <span class="cursor-pointer" v-if="showFullTextNotes">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up" />
              </span>
            </div>
          </div>

          <p v-if="taskForm.notes && taskForm.notes.length <= 300" class="text-formatted">
            {{ taskForm.notes }}
          </p>

          <p v-if="!taskForm.notes" qid="no-results-row-rr" class="text-muted" style="margin-top: 20px;">
            {{ $t('system.no_results') }}
          </p>
        </div>
      </b-form-group>

    </div>
  </div>
</template>


<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModalChatNotesCard',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Avatar
  },
  data() {
    return {
      pendingSubmitScroll: false,
      hasInitialScrollRun: false,
      lastCommentsKey: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeChatInput();
      this.lastCommentsKey = this.getCommentsKey(this.previousComments);
    });
  },
  updated() {
    this.$nextTick(() => {
      this.resizeChatInput();

      const comments = this.previousComments || [];
      const nextKey = this.getCommentsKey(comments);
      const commentsChanged = nextKey !== this.lastCommentsKey;

      if (!this.hasInitialScrollRun && comments.length > 0) {
        this.scrollToBottom('smooth');
        this.hasInitialScrollRun = true;
      } else if (this.pendingSubmitScroll && commentsChanged) {
        this.scrollToBottom('smooth');
        this.pendingSubmitScroll = false;
      }

      this.lastCommentsKey = nextKey;
    });
  },
  methods: {
    handleAddCommentSubmit() {
      this.pendingSubmitScroll = true;
      this.addCommentSubmit();
      setTimeout(() => {
        if (this.pendingSubmitScroll) {
          this.scrollToBottom('smooth');
        }
      }, 800);
    },
    getCommentsKey(list) {
      if (!list || !list.length) return '0';
      const last = list[list.length - 1] || {};
      return `${list.length}-${last.id || ''}-${last.updated_at || ''}`;
    },
    scrollToBottom(behavior = 'smooth') {
      const container = this.$refs.chatContainer;
      if (!container) return;
      container.scrollTo({
        top: container.scrollHeight,
        behavior
      });
    },
    resizeChatInput() {
      const refRaw = this.$refs.chatInput;
      const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw;
      if (!ref) return;
      const el = ref.$el
        ? (ref.$el.querySelector && ref.$el.querySelector('textarea')) || ref.$el
        : ref;
      if (!el || !el.style) return;
      const min = 36;
      const max = 144;
      el.style.minHeight = `${min}px`;
      el.style.height = 'auto';
      const next = Math.max(min, Math.min(el.scrollHeight || min, max));
      el.style.height = `${next}px`;
      el.style.overflowY = next >= max ? 'scroll' : 'hidden';
    }
  }
};
</script>
